import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get(`program-curriculum-accreditation-data`)
}
